import { Controller } from "stimulus"

export default class extends Controller
  @targets: ["content"]

  toggle: ->
    $(@contentTarget).toggleClass('col-xs-collapse__content--show')